<template>
  <section
    data-background-opacity="0.4"
    :data-background-video="videoUrl" 
    :data-background-image="gifUrl" 
    data-background-video-loop="true"
  >
    <div
      class="sl-block"
      data-block-type="text"
      style="width: 800px; margin: auto"
    >
      <weather
        units="us"
        :title="title"
        :currentDay="currentDay"
        :forecast="forecast"
        :enable-credits="false"
      />
    </div>
  </section>
</template>

<script>
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
import Weather from "./weather/Weather.vue";
import Trimaster from "@/plugins/servers/trimaster.js";

export default {
  name: "",
  props: [],
  components: { Weather },
  beforeMount() {
    let me = this;
    
    if (navigator.userAgent.indexOf('Silk') > 0) {
      this.gifUrl = "/img/presentationbackgrounds/weather.gif";
    } else {
      this.videoUrl = "/img/presentationbackgrounds/weather.mp4";
    }
    Trimaster.get(
      "facilities/" + this.getUser.facility_id,
      this.getUser.apitoken
    ).then(function ([res]) {
      me.facility = res;
      me.refresh();
    });
    // refresh every 15 minutes
    this.timer = setInterval(this.refresh, 15 * 60 * 1000);
  },
  mounted() {},
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  data() {
    return {
      title: "",
      videoUrl: null,
      gifUrl: null,
      facility: {
        city: "",
        state: "",
      },
      currentDay: {
       // iconUrl: "fog",
        temp: "17",
        currentSummary: "Fog.",
        hourlySummary: "Partly cloudy throughout the day.",
        windSpeed: 6,
      },
      forecast: [
        {
          name: "Today",
          icon: "clear-day",
          highTemp: "37",
          lowTemp: "32",
        },
        {
          name: "Wed",
          icon: "clear-day",
          highTemp: "34",
          lowTemp: "29",
        },
        {
          name: "Thu",
          icon: "clear-day",
          highTemp: "35",
          lowTemp: "30",
        },
        {
          name: "Fri",
          icon: "clear-day",
          highTemp: "32",
          lowTemp: "24",
        },
        {
          name: "Sat",
          icon: "clear-day",
          highTemp: "-7",
          lowTemp: "-18",
        },
        {
          name: "Sun",
          icon: "clear-day",
          highTemp: "23",
          lowTemp: "18",
        },
        {
          name: "Mon",
          icon: "clear-day",
          highTemp: "-1",
          lowTemp: "-6",
        },
        {
          name: "Tue",
          icon: "clear-day",
          highTemp: "13",
          lowTemp: "7",
        },
      ],
      timer: null,
    };
  },

  computed: {
    ...mapGetters(["getUser"]),
  },
  watch: {},
  methods: {
    refresh() {
      let me = this;

      this.title =
        this.facility.city +
        "," +
        this.facility.state +
        " @ " +
        moment
          .utc()
          .add(this.getUser.facility_UTCOffset, "hours")
          .format("h:mm a");
      fetch(
        "https://api.weatherapi.com/v1/forecast.json?key=40c19300230849f49de194910212301&days=7&q=" +
          this.facility.latitude +
          "," +
          this.facility.longitude
      )
        .then((response) => response.json())
        .then(function (data) {
      
          me.currentDay = {
            iconUrl: data.current.condition.icon,
            temp: data.current.temp_f,
            currentSummary: data.current.condition.text,
            hourlySummary: "Feels like " + data.current.feelslike_f + "˚",
            windSpeed: data.current.wind_mph,
          };
          let forecast = [];
          for (let i = 0; i < data.forecast.forecastday.length; i++) {
            let rec = {
              name: moment(data.forecast.forecastday[i].date).format("ddd"),
              icon: data.forecast.forecastday[i].day.condition.icon,
              highTemp: data.forecast.forecastday[i].day.maxtemp_f,
              lowTemp: data.forecast.forecastday[i].day.mintemp_f,
            };
            forecast.push(rec);
          }

          me.forecast = forecast;
        });
    },
  },
};
</script>
<style>
</style>

